import { Routes } from "@angular/router";
import { LoginComponent } from "../components/login/login.component";
import { LayoutBeforeLoginComponent } from "@components/layouts/layout-before-login/layout-before-login.component";
import { OtpVerificationComponent } from "@components/otp-verification/otp-verification.component";
import { ResetPasswordComponent } from "@components/reset-password/reset-password.component";
import { LayoutAfterLoginComponent } from "@components/layouts/layout-after-login/layout-after-login.component";
import { LayoutCreateComponent } from "@components/layouts/layout-create/layout-create.component";
import { RequestsComponent } from "@components/requests/requests.component";
import { SignComponent } from "@components/sign/sign.component";
import { afterLoginAuthGuard, adminAuthGuard, beforeLoginAuthGuard } from "@guards/auth.guard";
import { SettingsComponent } from "@components/settings/settings.component";
import { CustomersComponent } from "@components/customers/customers.component";
import { BlogsComponent } from "@components/blogs/blogs.component";
import { Constants } from "./constants";
import { NewRequestComponent } from "@components/new-request/new-request.component";
import { CreateEditEmailTemplateComponent } from "@components/create-edit-email-template/create-edit-email-template.component";
import { EmailTemplateComponent } from "@components/email-template/email-template.component";
import { CreateSignStepperComponent } from "@components/create-sign-stepper/create-sign-stepper.component";
import { BulkSignStepperComponent } from "@components/bulk-sign-stepper/bulk-sign-stepper.component";
// import { DashboardCreateComponent } from "@components/dashboard-create/dashboard-create.component";
import { SupportComponent } from "@components/support/support.component";
import { LayoutGuestSignComponent } from "@components/layouts/layout-guest-sign/layout-guest-sign.component";
const titleSuffix = (title: string) => {
  return `${title} | Kaizen`;
};

export const routes: Routes = [
  {
    path: "",
    component: LayoutBeforeLoginComponent,
    canActivateChild: [beforeLoginAuthGuard],
    children: [
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "login",
        component: LoginComponent,
        title: titleSuffix("Login"),
      },
      {
        path: "reset-password",
        component: ResetPasswordComponent,
        title: titleSuffix("Reset Password"),
      },
      {
        path: "reset-password/:token",
        component: ResetPasswordComponent,
        title: titleSuffix("Reset Password"),
      },
      {
        path: "otp-verification",
        component: OtpVerificationComponent,
        title: titleSuffix("OTP Verification"),
      },
    ],
  },
  {
    path: "",
    component: LayoutCreateComponent,
    canActivateChild: [afterLoginAuthGuard],
    children: [
      {
        path: "",
        redirectTo: Constants.DEFAULT_ROUTE_AFTER_LOGIN,
        pathMatch: "full",
      },
      {
        path: "requests",
        component: RequestsComponent,
        title: titleSuffix("My Requests")
      },
      {
        path: "requests/new",
        component: NewRequestComponent,
        title: titleSuffix("New Request"),
      },
      {
        path: "create",
        redirectTo: "requests",
        pathMatch: "full",
      },
      // {
      //   path: "create",
      //   component: DashboardCreateComponent,
      //   title: titleSuffix("Home"),
      // },
      {
        path: 'create/new',
        component: CreateSignStepperComponent,
        title: titleSuffix("Create Sign Request"),
      },
      {
        path: "edit/:requestID",
        component: CreateSignStepperComponent,
        title: titleSuffix("Edit Sign Request"),
        data: {
          isDraftRequest: true,
        },
      },
      {
        path: "create/bulk",
        component: BulkSignStepperComponent,
        title: titleSuffix("Bulk Sign Request"),
      },
      {
        path: "settings",
        component: SettingsComponent,
        title: titleSuffix("Settings"),
      },
      {
        path: "customers",
        component: CustomersComponent,
        canActivate: [adminAuthGuard],
        title: titleSuffix("Customers"),
        data: {
          isAdminOnly: true,
        },
      },
      {
        path: "customers/:customerID",
        component: CustomersComponent,
        canActivate: [adminAuthGuard],
        title: titleSuffix("Customer Details and Subscriptions"),
        data: {
          isAdminOnly: true,
        },
      },
      {
        path: "UploadFile",
        redirectTo: "customers",
        pathMatch: "full",
      },
      {
        path: "UploadFile/:UploadFileID",
        component: CustomersComponent,
        canActivate: [adminAuthGuard],
        title: titleSuffix("Customer Details and Subscriptions"),
        data: {
          isAdminOnly: true,
        },
      },
      {
        path: "support",
        component: SupportComponent,
        title: titleSuffix("Support"),
      },
      {
        path: "blogs",
        component: BlogsComponent,
        title: titleSuffix("Blogs"),
      },
      {
        path: "email-templates",
        component: EmailTemplateComponent,
        title: titleSuffix("Email Templates"),
      },
      {
        path: "email-templates/new",
        component: CreateEditEmailTemplateComponent,
        title: titleSuffix("New Email Template"),
      },
      {
        path: "email-templates/edit/:emailTemplateID",
        component: CreateEditEmailTemplateComponent,
        title: titleSuffix("Edit Email Template"),
        data: {
          isEdit: true
        }
      },
    ],
  },
  {
    path: "",
    component: LayoutGuestSignComponent,
    children: [
      {
        path: "sign/:requestID/:signerID",
        component: SignComponent,
      },
      {
        path: "view/:requestID",
        component: SignComponent,
        data: {
          isView: true,
        },
      },
    ]
  },
  {
    path: "**",
    redirectTo: "/",
    pathMatch: "full",
  },
];
